/**
 * Util class for manipulating byte Arrays and
 * their Hex string representations
 */
export class HexEncoder {
    public static xor(first: Uint8Array, second: Uint8Array): Uint8Array {
        const maxLen = Math.max(first.length, second.length);
        const output = new Uint8Array(maxLen);

        for (let i = 0; i < maxLen; i += 1) {
            const ordA = first[i % first.length];
            const ordB = second[i % second.length];
            output[i] = ordA ^ ordB;
        }

        return output;
    }
}
